import useGetDefault from '../hooks/use-get-default'

function GetDefault() {
  useGetDefault()

  return <></>
}

export default GetDefault
